import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import findServico from '../../service/findServico';
import { Button } from 'primereact/button';
import { SortOrder } from 'primereact/api';
import { useGlobalState } from '../../components/globalState/GlobalStateProvider';
import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { Nullable } from 'primereact/ts-helpers';
import getTipoBilhete from '../../service/getTipoBilhete';
import { Dropdown } from 'primereact/dropdown';




export default function ServicoList({onEdit}:{onEdit:(user:any)=>void}) {
  const { t } = useTranslation();
  const [servicos, setServicos] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  const {state} = useGlobalState();
  const [descricao, setDescricao] = useState<Nullable<String | null>>(null);
  const [tipoBilhete, setTipoBilhete] = useState<Nullable<String | null>>(null);
  const [tiposBilhete, setTiposBilhete] = useState<any>([]);
  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    descricao: descricao,
    tipoBilhete: tipoBilhete,
    idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
    sortField: 'descricao',
    sortOrder: SortOrder.DESC
  });

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      descricao: descricao,
      tipoBilhete: tipoBilhete,
      idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };
  const onSort = (event:any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      descricao: descricao,
      tipoBilhete: tipoBilhete,
      idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const loadLazyData = () => {
    findServico(lazyState).then(data => {setTotalRecords(data.total);setServicos(data.servicos)}).catch(() => {setTotalRecords(0);setServicos(undefined)});
  }

  const changeDescricao = (desc:Nullable<String>) => {
    if(desc){
      setDescricao(desc);
      setlazyState({
        first: 0,
        rows: 10,
        page: 1,
        descricao: desc,
        tipoBilhete: tipoBilhete,
        idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        sortField: 'descricao',
        sortOrder: SortOrder.ASC
      });
    }
  }

  const changeTipoBilhete = (tipo:Nullable<String>) => {
    if(tipo){
      setTipoBilhete(tipo);
      setlazyState({
        first: 0,
        rows: 10,
        page: 1,
        descricao: descricao,
        tipoBilhete: tipo,
        idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        sortField: 'descricao',
        sortOrder: SortOrder.ASC
      });
    }
    else{
      setTipoBilhete(null);
      setlazyState({
        first: 0,
        rows: 10,
        page: 1,
        descricao: descricao,
        tipoBilhete: null,
        idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        sortField: 'descricao',
        sortOrder: SortOrder.ASC
      });
    }
  }

  const startContent = (
    <React.Fragment>
      <div  style={{background:'transparent'}}>
        <div className="grid">
              
              <div className="col p-fluid flex flex-wrap">
                <div >
                  <div className="flex-auto">
                      <label htmlFor="descricao" className="font-bold block mb-2">{t('descricao')} </label>
                      <InputText id="descricao" onBlur={(e)=>changeDescricao(e.target.value)} style={{width: '20rem'}}></InputText>
                  </div>
                </div>
              </div>
              <div className="col p-fluid flex flex-wrap">
                <div>
                  <div className="flex-auto" style={{visibility: state.user.cliente ? 'hidden': 'visible'}}>
                    <label htmlFor="documento" className="font-bold block mb-2">
                      {t("tipoBilhete")}{" "}
                    </label>
                      <Dropdown disabled={state.user.cliente} style={{width: '50%'}} value={tipoBilhete} onChange={(e) => {changeTipoBilhete(e.value)}} options={tiposBilhete} optionLabel="label" placeholder="Selecione Tipo Bilhete" 
                                          showClear  filter className="w-full md:w-14rem" />  
                  </div>
                </div>
              </div>
        
            
          
        </div>
      </div>
    </React.Fragment>
  );

  const editBodyTemplate = (servico:any) => {
    return <Button icon="pi pi-pencil" onClick={() => onEdit(servico)} style={{background:'transparent', color:'gray', border: 'none'}} />;
  };
  
  useEffect(() => {
    getTipoBilhete().then( (data) => setTiposBilhete(data))
    loadLazyData();
  },[lazyState])

  return (
    <div>
      <div>
        <Toolbar start={startContent} />
        <br></br>
        <br></br>
        <DataTable value={servicos} first={lazyState.first} dataKey="id" paginator={true}  lazy={true}
                        emptyMessage="Sem registros"
                        onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                        rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
                        tableStyle={{ minWidth: '75rem' }}>
           <Column field="tipoBilhete" sortable sortField='tipoBilhete' header={t('tipoBilhete')}  />
           <Column field="descricao" sortable sortField='descricao' header={t('descricao')}  />
           <Column body={editBodyTemplate} />
        </DataTable> 
      </div>
    </div>
  )
}


